document.addEventListener('DOMContentLoaded', () => {
    const btn = document.getElementById('scrollToTop');

    if (!btn) return;

    // Показ/скрытие при скролле
    window.addEventListener('scroll', () => {
        if (window.scrollY > window.innerHeight * 2) {
            btn.classList.remove('hidden');
        } else {
            btn.classList.add('hidden');
        }
    });

    // Скролл наверх
    btn.addEventListener('click', () => {
        window.scrollTo({
            top: 0,
            behavior: 'smooth'
        });
    });
});